import { createUseStyles } from '../../theme/theming';

const useVideoStyles = createUseStyles((theme) => {
  return {
    iframe: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      borderRadius: theme?.shape?.borderRadius?.regular,
      borderRadius: theme.shape.borderRadius.small
    },
    hideImg: {
      display: ({ isLoaded } = {}) => (isLoaded ? 'block' : 'none')
    },
    icon: {
      zIndex: '999',
      position: 'absolute'
    },

    imgContainer: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      borderRadius: theme.shape.borderRadius.small,
      // backgroundImage: ({ imageUrl } = {}) =>
      //   `linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%), url("${imageUrl}")`,
      background:
        'linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%)',
      backgroundSize: 'cover',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '& svg': {
        cursor: 'pointer'
      }
    },
    videoPlayerImage: {
      height: '100%',
      width: '100%',
      objectFit: 'cover',
      objectPosition: 'top',
      opacity: '0.8'
    },

    '@media (max-width: 767px)': {
      iframe: {
        borderRadius: '8px 8px 0 0'
      },

      imgContainer: {
        borderRadius: '8px 8px 0 0'
      }
    }
  };
});

export default useVideoStyles;
